// 
/**
 * Trigger Horizon's native parabolic Fly-To-Cart animation
 * @param {HTMLElement} sourceElem - the element where animation should start
 * @param {string} imageUrl - product image used as the flying item
 */
window.flyFrom = function (sourceElem, imageUrl) {
  if (!sourceElem) return;

  const cartIcon =
    document.querySelector(".header-actions__cart-icon") ||
    document.querySelector("[data-cart-icon]");

  if (!cartIcon) return;

  const fly = document.createElement("fly-to-cart");

  // Where animation begins
  fly.source = sourceElem;

  // Where animation ends (shop cart icon)
  fly.destination = cartIcon;

  // Set flying object image
  fly.style.setProperty("background-image", `url(${imageUrl})`);

  document.body.appendChild(fly);
};


// 

var $=jQuery

function checkHashUrl() {
  try {
    
  
  let target ="" ;
  
  if (document.querySelector(window.location.hash)) {
    target=document.querySelector(window.location.hash);
  }
    let header = document.querySelector('#header-component');
    console.log("target--",target);
    console.log("header--",header);
    if (window.location.hash.includes("#looxProductReviews")) {
      target=document.querySelector(".review-slider");
    }
    
    
    if (target) {
      let headerHeight = header ? header.offsetHeight : 80;
      if (headerHeight<10) {
        headerHeight=75
      }

      let targetPosition =
        target.getBoundingClientRect().top + window.pageYOffset;
        console.log("tt-",targetPosition);
        console.log("tt-",headerHeight);
        

      // Small delay to ensure layout is ready
      setTimeout(() => {
        window.scrollTo({
          top: targetPosition - headerHeight,
          behavior: 'smooth'
        });
      }, 200);
    }
    } catch (error) {
      console.log("Error--",error);
      
  }
}
if (window.location.hash.includes("#looxProductReviews")) {
  // Disable browser's automatic scroll restoration
  history.scrollRestoration = "manual";

  // Force scroll to top (or keep current position)
  window.scrollTo(0, 0);
}
$(document).ready(function () {
if (window.location.hash.includes("#looxProductReviews")) {
  // Disable browser's automatic scroll restoration
  history.scrollRestoration = "manual";

  // Force scroll to top (or keep current position)
  window.scrollTo(0, 0);
}
else{

  setTimeout(() => {
    
    if (window.location.hash) {
      checkHashUrl();
    }
  }, 100);
}
// $("a.looxStarRating").click(function () {
//   console.log("Go rating----");
  
//   checkHashUrl();
// });


// Code to manage quantity selector starts
$(".custom-qty-selector select").on("change", function () {
    let value = $(this).val(); // get selected value
    $("product-form-component .custom-qty-selector select").val(value).trigger("change"); // update all
});

$(document).on("quantity-selector:update",function(e){
  console.log("e----",e.originalEvent.detail);
  let updatedQty=e.originalEvent.detail.quantity
  
  let qty=$(".product-information quantity-selector-component input[name='quantity']").eq(0).val()
  $("product-form-component.main-buy-btns quantity-selector-component input[name='quantity']").val(qty)
   console.log("Test--1-",$(this))
})
// Code to manage quantity selector ends

    /******** CODE FOR CUSTOM TESTIMONIAL SECTION STARTS *********/
    let runOnceTimer;
    
    function handleSlideUpdated() {
      clearTimeout(runOnceTimer);
      runOnceTimer = setTimeout(runOnceAfterStop, 120);
    }
    
    function runOnceAfterStop() {
      // console.log("Slider stopped → run center active function here");
      onSlideChange();
    }
    
    // const slidesContainer = document.querySelector(".icon-with-text-slider slideshow-component slideshow-slides");
    const slidesContainer = document.querySelector(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides");
    
    if (slidesContainer) {
      new MutationObserver(handleSlideUpdated).observe(slidesContainer, {
        attributes: true,
        subtree: true,
    attributeFilter: ["aria-hidden"]
  });
}

function onSlideChange() {
  $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref]").removeClass("disable")
  // $(" slideshow-component slideshow-slides slideshow-slide").removeClass("active")
  // $(" slideshow-component slideshow-slides slideshow-slide").removeClass("active-near")
  let items = $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides").children("[aria-hidden='false']");
  console.log("Slide-change====");
  $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides slideshow-slide").removeClass("visible")
  $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides slideshow-slide[aria-hidden='false']").addClass("visible");
  if ($(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides slideshow-slide").eq(0).attr("aria-hidden")=="false") {
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref]").removeClass("disable")
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='previous']").addClass("disable")
    console.log("Disable prev--");
  }else{
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='previous']").removeClass("disable")
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='previous']").removeAttr("disabled")
  }
  
  if ($(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-slides slideshow-slide").last().attr("aria-hidden")=="false") {
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref]").removeClass("disable")
    
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='next']").addClass("disable")
    console.log("Disable next--");
  }
  else{
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='next']").removeClass("disable")
    $(".custom-testimonial.icon-with-text-slider slideshow-component slideshow-arrows button[ref='next']").removeAttr("disabled")
  }
  // let center = Math.floor(items.length / 2);
  // items.removeClass("active");
  // items.removeClass("active-near");
  // items.eq(center).addClass("active");
  if (items.length>1) {
    // items.eq(center+1).addClass("active-near");
    // items.eq(center-1).addClass("active-near");
  }
  
}
onSlideChange();
/******** CODE FOR CUSTOM TESTIMONIAL SECTION ENDS *********/

if (window.location.href.includes("/products")) {
$("a.act_as_atc").click(function (e) {
  e.preventDefault();
  console.log("Custom atc---",this)
   flyFrom(this, $(this).data("p-img"));
   $("add-to-cart-component button").trigger("click")
  // flyFromButtonToCart(this,$(this).data("p-img"));
  // $("fly-to-cart").hide()
});
$(document).on('variant:update',function(e){ 
  let data=e.originalEvent.detail.resource;
  if (data.available) {
    $("a.act_as_atc").removeAttr("aria-disabled")
  }
  else{
    $("a.act_as_atc").attr("aria-disabled",true)
  }
   
       console.log("Variant change===11",e.originalEvent.detail.resource)
   });
}
// 
$("blog-posts-list button.see-more").on('click',function(e){
  $("blog-posts-list .blog-post-item.hide").removeClass("hide")
});

if (window.location.href.includes("/product")) {
  
  let intr=setInterval(() => {
   const el = document.querySelector("loox-snippets-widget");
if (!el || !el.shadowRoot) return;
if (el) {
  clearInterval(intr);
}

const shadow = el.shadowRoot;
const innerEl = shadow.querySelector(".container");

const $inner = $(innerEl);
const $slides = $inner.find(".quickview-button");
$inner.find("button.arrow").removeAttr("style");

// --------------------
// Setup slides & text
// --------------------
$slides.each(function () {
  const $btn = $(this);
  $btn.addClass("slide");

  let text = $btn.find(".content .text").text().trim();
  text = text.replace(/^["']|["']$/g, ""); // remove outer quotes
  $btn.find(".content .text").text(text);
});

// Initial state
let index = 0;
$slides.hide().removeClass("active");
$slides.eq(index).show().addClass("active");

// --------------------
// Arrow navigation
// --------------------
$inner.find("button.arrow").removeAttr("style").on("click", function () {
  $slides.eq(index).stop(true, true).fadeOut(300).removeClass("active");

  if ($(this).hasClass("left")) {
    index = (index - 1 + $slides.length) % $slides.length;
  } else if ($(this).hasClass("right")) {
    index = (index + 1) % $slides.length;
  }

  $slides.eq(index).stop(true, true).fadeIn(300).addClass("active");
  resetAutoplay();
});

// --------------------
// Autoplay
// --------------------
let autoplay = setInterval(nextSlide, 5000);

function nextSlide() {
  $slides.eq(index).stop(true, true).fadeOut(300).removeClass("active");
  index = (index + 1) % $slides.length;
  $slides.eq(index).stop(true, true).fadeIn(300).addClass("active");
}

function resetAutoplay() {
  clearInterval(autoplay);
  autoplay = setInterval(nextSlide, 5000);
}

    
// 
if (!innerEl?.querySelector(".quickview-button")) {
  $(".product-details .snippet-widget.group-block").hide();
  return;
}
innerEl.querySelectorAll(".quickview-button").forEach(button => {
  // skip if image exists
  if (button.querySelector("img")) return;

  // get name element
  const nameEl = button.querySelector(".content strong.name");
  if (!nameEl) return;

  // get first letter
  const firstLetter = nameEl.textContent.trim().charAt(0).toUpperCase();
  if (!firstLetter) return;

  // avoid duplicates
  if (button.querySelector(".name-letter")) return;

  // prepend letter
  button.querySelector(".element").insertAdjacentHTML(
    "afterbegin",
    `<div class="name-letter">
      ${firstLetter}
    </div>`
  );
});


innerEl.insertAdjacentHTML(
  "afterend",
  `<style>
    .title {
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start !important;
    flex-direction: column-reverse;
    }
    .rating{
      width:100%;
      }
      .name-letter{
    background: green;
    aspect-ratio: 1;
    font-size: x-large;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--loox-snippets-border-radius) * .7);
    color: white;
    }
    .slide {
    display: none;
   }

  .slide.active {
    display: block;
  }
     [dir=ltr] .arrow.left{
      --loox-snippets-left-arrow-visibility:visible !important;
     }
      .arrow.right{
      --loox-snippets-right-arrow-visibility:visible !important;
      }
    [dir=ltr] .arrow.left,
    .arrow.right{
    opacity:1 !important; 
    }

  </style>`
);
let maxHeight=0
    console.log("Height=====");
    
$(innerEl).find(".quickview-button").each((i,j)=>{
   console.log("oo", $(j).outerHeight())
    if (maxHeight < $(j).outerHeight()) {
        maxHeight = $(j).outerHeight();
    } {
        
    }
})
$(innerEl).find(".quickview-button").css("height",maxHeight)
}, 1000);

}
const target = document.querySelector(".review-slider");

if (target) {
  const observer = new MutationObserver(() => {
    const iframe = target.querySelector(".loox-widget iframe");

    if (iframe) {
      console.log("Height===", iframe.offsetHeight);
      setTimeout(() => {
        if ($(".review-slider .loox-v2-carousel-container.loox-widget").parent()[0].style.height=="0px") {
          $(".review-slider .text-block, .review-slider .button").fadeOut()
          $(".review-slider").hide();
          console.log("Hide review---");
          
        }
        else{
          $(".review-slider .text-block, .review-slider .button").fadeIn()
          $(".review-slider").show();
          checkHashUrl()
          console.log("Show review---");
        }

        console.log("bb",$(".review-slider .loox-v2-carousel-container.loox-widget").parent().height());
      }, 2000);
      
      observer.disconnect();
    }
  });

  observer.observe(target, { childList: true, subtree: true });
}

// Code for click of "See how it works" button starts

if (document.querySelector('.meta-nutrition_system a.button')) {
  document.querySelector('.meta-nutrition_system a.button').addEventListener('click', function (e) {
      e.preventDefault();
    const section = document.querySelector('.meta-steps_section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  });
  
}



// Code for click of "See how it works" button ends

const section = document.querySelector(".review-slider");
{/* <script>
  $(document).ready(function () {
    
  //   window._klOnsite = window._klOnsite || [];

  // _klOnsite.push(['onFormReady', function (form) {
  //   console.log("Form loader----",form)
  //   // const loader = document.getElementById('klaviyo-form-loader');
  //   // if (loader) loader.style.display = 'none';
  // }]);
    const klWrapper = document.querySelector('.klaviyo-form-SQxrRQ');

  if (klWrapper) {
    const observer = new MutationObserver(() => {
      const iframe = klWrapper.querySelector('form');

      if (iframe ) {
        console.log('Klaviyo form loaded');

        // document.getElementById('klaviyo-form-loader')?.remove();

        observer.disconnect();
      }
    });

    observer.observe(klWrapper, {
      childList: true,
      subtree: true
    });
  }

})
</script> */}


// if (section) {
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         // console.log("review-slider is in view====");
//          if ($(".review-slider .loox-v2-carousel-container.loox-widget").parent()[0].style.height=="0px") {
//            $(".review-slider .text-block, .review-slider .button").hide()
//           $(".review-slider").hide();
//           console.log("Hide review---");
//         }
//         else{
//           $(".review-slider .text-block, .review-slider .button").show()
//           $(".review-slider").show()
//           console.log("Show review---");
//         }
//         // console.log("iii",$(".review-slider .loox-v2-carousel-container.loox-widget").parent().height());
//       } else {
//         // console.log("review-slider is OUT of view====");
//       }
//     });
//   }, {
//     root: null,       // viewport
//     threshold: 0.1    // trigger when 10% is visible
//   });

//   observer.observe(section);
// }

// 

});
// function flyFromButtonToCart(btn,image) {
//   const cartIcon = document.querySelector('.header-actions__cart-icon');
//   if (!cartIcon || !btn) return;

//   const btnRect = btn.getBoundingClientRect();
//   const cartRect = cartIcon.getBoundingClientRect();

//   const ball = document.createElement('div');
//   ball.style.position = 'fixed';
//   ball.style.left = btnRect.left + 'px';
//   ball.style.top = btnRect.top + 'px';
//   ball.style.width = '40px';
//   ball.style.height = '40px';
//   ball.style.borderRadius = '50%';
//   ball.style.setProperty('background-image', `url(${image})`);
//   ball.style.setProperty('border', `1px solid black`);
//   ball.style.zIndex = '999999';
//   ball.style.transition = 'all .7s cubic-bezier(.25, .46, .45, .94)';

//   document.body.appendChild(ball);

//   requestAnimationFrame(() => {
//     ball.style.left = cartRect.left + 'px';
//     ball.style.top = cartRect.top + 'px';
//     ball.style.transform = 'scale(0.2)';
//     ball.style.opacity = '0.9';
//   });

//   ball.addEventListener('transitionend', () => ball.remove());
// }
document.addEventListener('DOMContentLoaded', () => {
  $(document).on("cart:update",async function(e){
    console.log("Cart updated----",e);
    if (window.location.href.includes("/cart")) {
      const html = await fetch('/cart').then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
      document.querySelector("#cart-recommendations-section").outerHTML=doc.querySelector("#cart-recommendations-section").outerHTML;
      if(!document.querySelectorAll(".recommendation-items .recommendation-card").length){
            $(".cart-recomdation-products").css("display","none");
            console.log("t--1",$(".cart-recomdation-products").length)
      }
      else{
        console.log("t--2",$(".cart-recomdation-products").length)
        $(".cart-recomdation-products").show()
      }
    }
    
  })
  console.log("rec===",document.querySelectorAll(".recommendation-item .recommendation-card"))
  console.log($(".cart-recomdation-products"))
  setTimeout(()=>{
    if(!document.querySelectorAll(".recommendation-items .recommendation-card").length){
            $(".cart-recomdation-products").css("display","none");
            console.log("t--1",$(".cart-recomdation-products").length)
          }
          else{
            console.log("t--2",$(".cart-recomdation-products").length)
            $(".cart-recomdation-products").show()
          }
  },1000)


  /******** CODE FOR CART RECOMMENDATION STARTS ********/

  /* ===============================
     VARIANT CHANGE (DELEGATED)
  =============================== */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('.variant-select');
    if (!select) return;

    const card = select.closest('.recommendation-card');
    if (!card) return;

    const option = select.options[select.selectedIndex];

    card.querySelector('.hidden-variant-id').value = option.value;
    card.querySelector('.recommendation-card__price').textContent =
      option.dataset.price;

    const btn = card.querySelector('.recommendation-add-btn');
    btn.disabled = option.disabled;
    btn.textContent = option.disabled ? 'Sold out' : 'Add';
  });

  /* ===============================
     ADD TO CART (DELEGATED)
  =============================== */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.custom-ajax-cart-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    const button = form.querySelector('.recommendation-add-btn');
    const card = form.closest('.recommendation-card');
    const id=form.querySelector(".hidden-variant-id").value
    const qty = form.querySelector("input[name='qty']").value;
    console.log("id===",id)
    console.log("qty===",qty)
    console.log("Form---",form);
    

    if (form.dataset.loading === 'true') return;
    form.dataset.loading = 'true';

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      /*  ADD TO CART */
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      if (!addRes.ok) throw new Error('Add failed');

      /*  REMOVE RECOMMENDATION CARD */
      card.style.opacity = '0';
      card.style.transform = 'translateY(-8px)';
      setTimeout(() => card.remove(), 250);

      if (window.location.href.includes("/cart")) {
        window.location.reload();
        // return;
      }

      /*  REFRESH CART DRAWER (HORIZON SAFE) */
      const html = await fetch('/').then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newHeader = doc.querySelector('#cart-drawer-header');
      const newCartInner = doc.querySelector('.cart-drawer__inner');
      // const newDrawer = doc.querySelector('#cart-items-drawer');
      const newTotal = doc.querySelector('.cart__summary-item.cart__total');

      // document.querySelector('#cart-items-drawer').outerHTML = newDrawer.outerHTML;
      // document.querySelector('.cart__summary-item.cart__total').outerHTML = newTotal.outerHTML;
      // document.querySelector('.cart-drawer__inner').outerHTML = newCartInner.outerHTML;
      
      document.querySelector(".cart-drawer__inner").outerHTML=doc.querySelector(".cart-drawer__inner").outerHTML
      if ($(".cart-drawer--empty").length) {
        $(".cart-drawer--empty").removeClass("cart-drawer--empty")
      }
      
      if(!doc.querySelectorAll(".recommendation-items .recommendation-card").length){
        $(".cart-recomdation-products").fadeOut()
      }
      else{
        $(".cart-recomdation-products").fadeIn()
      }
      if (newHeader) {
        // document.querySelector('#cart-drawer-header').outerHTML = newHeader.outerHTML;
      }
      $(document).trigger("cart:update")

    } catch (err) {
      console.error(err);
      button.disabled = false;
      button.textContent = 'Add';
      alert('Add to cart failed');
    } finally {
      delete form.dataset.loading;
    }
  });
    /******** CODE FOR CART RECOMMENDATION ENDS ********/


// document.addEventListener('click', (e) => {
//   console.log("doc click===")
//   const btn = e.target.closest('.recommendation-add-btn');
//   if (!btn) return;

//   e.preventDefault();
//   e.stopImmediatePropagation();

//   console.log('Button clicked (works even if added later)',$(this).parents(".custom-ajax-cart-form"));
//   let id=$(this).parents(".custom-ajax-cart-form").find("input[name=id]").val()
//    console.log("id===",id);
//    console.log($(this));
   
   
// });
document.addEventListener("click", function (e) {
  const playBtn = e.target.closest(
    'deferred-media button[ref="deferredMediaPlayButton"]'
  );

  if (!playBtn) return;

  // Wait until Shopify injects the iframe
  setTimeout(() => {
    const deferredMedia = playBtn.closest("deferred-media");
    if (!deferredMedia) return;

    const iframe = deferredMedia.querySelector(
      'iframe[src*="vimeo.com"]'
    );
    if (!iframe) return;

    if (iframe._vimeoPlayer) return; // prevent duplicate init

    const player = new Vimeo.Player(iframe);
    iframe._vimeoPlayer = player;

    // Ensure sound (user gesture already happened)
    player.play().catch(err => {
      console.error("Vimeo play failed:", err);
    });
    // player.setMuted(false).catch(() => {console.log("V--error")});
    // player.setVolume(1).catch(() => {});
    console.log("Vimeo click---");
    

  }, 100); // Shopify needs a tick to inject iframe
});


});
(function () {
  const fixSafariSliderStart = () => {
    document.querySelectorAll('slideshow-component').forEach(slider => {
      const track =
        slider.querySelector('slideshow-slides') ||
        slider.querySelector('slideshow-slide');

      if (!track) return;

      // Force reset (Safari sometimes ignores smooth)
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;

      // Re-apply after Safari restores scroll
      requestAnimationFrame(() => {
        track.scrollLeft = 0;
      });

      setTimeout(() => {
        track.scrollLeft = 0;
      }, 100);
    });
  };

  // DOM ready
  document.addEventListener('DOMContentLoaded', fixSafariSliderStart);

  // Safari bfcache restore
  window.addEventListener('pageshow', e => {
    if (e.persisted) fixSafariSliderStart();
  });

  // After images load (Safari layout shift)
  window.addEventListener('load', fixSafariSliderStart);
})();



/********  Code for review slider on home page starts *******/

document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelectorAll('.resource-list__carousel slideshow-componen,'+'.icon-with-text-slider slideshow-component').forEach(slider => {
    const track =
    slider.querySelector('.slider__slides') ||
    slider.querySelector('slideshow-slides');

      if (!track) return;
      
      const slides = track.children;
      if (!slides.length) return;
      
      const slideWidth = slides[0].getBoundingClientRect().width;
      
      // Find ANY previous / next button inside this slider
      const prev = slider.querySelector(
        'button[ref="previous"], .slider-button--prev, .slideshow__control--prev'
      );
      const next = slider.querySelector(
        'button[ref="next"], .slider-button--next, .slideshow__control--next'
      );
      console.log("Next--",next)
      console.log("Previous--",prev)
      if (prev) {
        prev.addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation(); // STOP Horizon logic
          track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
          console.log("previous-custom--")
        });
      }
      
      if (next) {
        next.addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation(); // STOP Horizon logic
          track.scrollBy({ left: slideWidth, behavior: 'smooth' });
          console.log("next-custom--")
        });
      }
    });
  });

// 

$(document).ready(function () {
  console.log('Pagination----');

  $('slideshow-component').each(function () {

    const slider = this;

    const track =
      slider.querySelector('.slider__slides') ||
      slider.querySelector('slideshow-slides');

    if (!track || !track.children.length) return;

    const slides = Array.from(track.children);
    const pagination = slider.querySelector('.slider-pagination');

    if (!pagination) return;

    /* ------------------------
       HELPERS
    ------------------------ */

    const getSlideWidth = () =>
      slides[0].getBoundingClientRect().width;

    const getSlidesPerView = () => {
      const slideWidth = getSlideWidth();
      if (!slideWidth) return 1;
      return Math.round(track.clientWidth / slideWidth);
    };

    /* ------------------------
       CREATE PAGINATION DOTS
    ------------------------ */

    const createPagination = () => {
      pagination.innerHTML = '';

      const slidesPerView = getSlidesPerView();
      const pageCount = Math.max(
        slides.length - slidesPerView + 1,
        1
      );

      for (let i = 0; i < pageCount; i++) {
        const dot = document.createElement('button');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        pagination.appendChild(dot);

        dot.addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation();

          track.scrollTo({
            left: i * getSlideWidth(),
            behavior: 'smooth'
          });
        });
      }
    };

    /* ------------------------
       UPDATE ACTIVE DOT
    ------------------------ */

    const updatePagination = () => {
      const slideWidth = getSlideWidth();
      if (!slideWidth) return;

      const slidesPerView = getSlidesPerView();
      const maxIndex = slides.length - slidesPerView;

      let index = Math.round(track.scrollLeft / slideWidth);
      index = Math.max(0, Math.min(index, maxIndex));

      $(pagination)
        .children('button')
        .removeClass('is-active')
        .eq(index)
        .addClass('is-active');
    };

    /* ------------------------
       INIT
    ------------------------ */

    createPagination();
    requestAnimationFrame(updatePagination);

    /* ------------------------
       EVENTS
    ------------------------ */

    track.addEventListener('scroll', () => {
      requestAnimationFrame(updatePagination);
    });

    window.addEventListener('resize', () => {
      createPagination();
      requestAnimationFrame(updatePagination);
    });
  });
});

// 



  /********  Code for review slider on home page ends *******/

//   document.addEventListener('DOMContentLoaded', () => {
//   document
//     .querySelectorAll('slider-component,.icon-with-text-slider slideshow-component')
//     .forEach(slider => {

//       const track =
//         slider.querySelector('.slider__slides') ||
//         slider.querySelector('.slideshow__slides');

//       if (!track) return;

//       const slides = track.children;
//       if (!slides.length) return;

//       const slideWidth = slides[0].getBoundingClientRect().width;

//       const prev = slider.querySelector(
//         'button[ref="previous"], .slider-button--prev, .slideshow__control--prev'
//       );
//       const next = slider.querySelector(
//         'button[ref="next"], .slider-button--next, .slideshow__control--next'
//       );

//       // --- helper: update button state ---
//       const updateButtons = () => {
//         const atStart = track.scrollLeft <= 0;
//         const atEnd =
//           track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

//         if (prev) {
//           prev.disabled = atStart;
//           prev.classList.toggle('is-disabled', atStart);
//         }

//         if (next) {
//           next.disabled = atEnd;
//           next.classList.toggle('is-disabled', atEnd);
//         }
//       };

//       // initial state
//       updateButtons();

//       if (prev) {
//         prev.addEventListener('click', e => {
//           if (prev.disabled) return;

//           e.preventDefault();
//           e.stopImmediatePropagation();

//           track.scrollBy({ left: -slideWidth, behavior: 'smooth' });

//           // update after scroll finishes
//           setTimeout(updateButtons, 300);
//         });
//       }

//       if (next) {
//         next.addEventListener('click', e => {
//           if (next.disabled) return;

//           e.preventDefault();
//           e.stopImmediatePropagation();

//           track.scrollBy({ left: slideWidth, behavior: 'smooth' });

//           setTimeout(updateButtons, 300);
//         });
//       }

//       // update state on manual drag / scroll
//       track.addEventListener('scroll', () => {
//         updateButtons();
//       });
//     });
// });





// thumbnail dragging
document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".slideshow-controls__thumbnails-container");
  if (!slider) return;

  let isDown = false;
  let velocity = 0;
  let lastX;
  let momentumID;

  const speed = 2; // drag speed multiplier (increase this)

  // ----- Mouse Down -----
  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.style.cursor = "grabbing";

    lastX = e.pageX;
    cancelMomentum();
  });

  // ----- Mouse Move -----
  slider.addEventListener("mousemove", (e) => {

    if (!isDown || e.buttons !== 1) return;

    e.preventDefault();

    const dx = (e.pageX - lastX) * speed;
    slider.scrollLeft -= dx;

    velocity = dx;
    lastX = e.pageX;
  });

  // ----- Mouse Up / Leave -----
  slider.addEventListener("mouseup", stopDrag);
  slider.addEventListener("mouseleave", stopDrag);

  function stopDrag() {
    if (!isDown) return;

    isDown = false;
    slider.style.cursor = "grab";
    startMomentum();
  }

  // ----- Momentum -----
  function startMomentum() {
    momentumID = requestAnimationFrame(momentumLoop);
  }

  function momentumLoop() {
    slider.scrollLeft -= velocity;
    velocity *= 0.95;

    if (Math.abs(velocity) > 0.3) {
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }

  function cancelMomentum() {
    cancelAnimationFrame(momentumID);
  }

});
